<template>
  <div id="app" class="adminWrapper">
    <b-overlay
      :fixed="true"
      no-wrap
      :show="sharedState.overlayShow"
    ></b-overlay>
    <b-row
      v-if="showSidebarFooter && isAuthenticated"
      no-gutters
      class="rowMainWrapper"
    >
      <b-col :cols="2" class="sidebarColWrapper">
        <Sidebar />
      </b-col>
      <b-col>
        <b-row v-if="showStagingAlert">
          <b-col cols="12" class="text-center">
            <b-alert show variant="warning"
              >Estás utilizando el entorno de pruebas</b-alert
            >
          </b-col>
        </b-row>
        <router-view></router-view>
      </b-col>
    </b-row>
    <router-view v-else></router-view>
    <notifications position="bottom right" />
    <!-- <Footer ref="footer" /> -->
  </div>
</template>

<script>
import { actions } from '@/admin/api.js';

import store from '@/admin/store.js';
import Sidebar from '@/admin/layout/Sidebar.vue';

export default {
  name: 'AdminMainWrapper',
  props: {
    msg: String,
  },
  components: { Sidebar },
  data() {
    return { sharedState: store.state };
  },
  created() {
    let token = localStorage.getItem('token_a');
    if (token) {
      actions.getAuth(token).then((x) => {
        if (x.data.auth === false) {
          store.setAuth(false, null, null, null);
          this.$router.replace({ name: 'LoginScreen' });
        } else {
          store.setAuth(true, token, x.data.role, x.data.locations);
          this.$router.replace({
            name:
              this.$route.params &&
              this.$route.params
                .redirect /*&&
              this.$route.params.redirect !== 'LoginScreen'*/
                ? this.$route.params.redirect
                : 'AdminMainScreen',
            params:
              this.$route.params && this.$route.params.params
                ? this.$route.params.params
                : {},
          });
        }
      });
    }
  },
  mounted() {},
  methods: {},
  computed: {
    showStagingAlert() {
      return process.env.NODE_ENV === 'staging';
    },
    showSidebarFooter() {
      return !['LoginScreen', 'LogoutScreen'].includes(this.$route.name);
    },
    isAuthenticated() {
      return this.sharedState.auth.isAuthenticated;
    },
  },
  watch: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss">
@import '@/assets/css/admin/styles.scss';
</style>
